import { LocaleSyntax } from '../../Types.js'

const locale: LocaleSyntax = Object.freeze({
  // consonants except hard to speak ones
  consonants: 'bcdfghjklmnprstvwz',
  vowels: 'aeiou',
})

export default locale
